export default __webpack_public_path__ + "static/media/user-white.63d048a0.svg";